import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { from, map } from 'rxjs';
import { AiCreditsService } from 'src/app/settings/services/ai-credits.service';

@Component({
  selector: 'ai-top-off',
  providers: [DecimalPipe],
  template: `
    <p class="tw-flex tw-flex-col">
      <span id="ai-top-off"> Total monthly credits: {{ totalCredits() }} </span>
      <span> Credit reset start of each month. </span>
    </p>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiTopOffComponent {
  decimalPipe = inject(DecimalPipe);
  totalCredits = toSignal(
    from(this.aiCreditsService.getAICredits()).pipe(
      map((credits) =>
        this.decimalPipe.transform(credits.creditsTotal, '1.0-0'),
      ),
    ),
  );

  constructor(private aiCreditsService: AiCreditsService) {}
}
